// utils/socialAuthHandler.js
import { ref, get, set, update } from 'firebase/database';

export const handleSocialAuth = async (user, db, provider = 'facebook') => {
    try {
        // First, search for any existing accounts with the same email
        const usersRef = ref(db, 'users');
        const usersSnapshot = await get(usersRef);
        const users = usersSnapshot.val() || {};
        
        // Find any existing user with the same email
        const existingUserEntry = Object.entries(users).find(([_, userData]) => 
            userData.email === user.email
        );

        if (existingUserEntry) {
            // If we found an existing user, use that ID and data
            const [existingUserId, existingUserData] = existingUserEntry;
            
            // Update the existing user's data
            await update(ref(db, `users/${existingUserId}`), {
                lastLogin: new Date().toISOString(),
                providers: {
                    ...(existingUserData.providers || {}),
                    [provider]: true
                }
            });
            
            return {
                uid: existingUserId,
                email: existingUserData.email,
                username: existingUserData.username
            };
        }

        // If no existing user was found, create a new user entry
        const newUserData = {
            email: user.email || `${user.uid}@${provider}.com`,
            username: user.displayName || `User${user.uid.slice(0, 5)}`,
            createdAt: new Date().toISOString(),
            lastLogin: new Date().toISOString(),
            providers: {
                [provider]: true
            }
        };
        
        await set(ref(db, `users/${user.uid}`), newUserData);
        
        return {
            uid: user.uid,
            email: newUserData.email,
            username: newUserData.username
        };
    } catch (error) {
        console.error('Error in handleSocialAuth:', error);
        throw error;
    }
};